import React from 'react';
import {Link} from 'react-router-dom';
import ViewTitle from '../ViewTitle';
import Paragraph from '../Paragraph';
import './styles.scss';

const Index = (props) => {
  return (
    <div className="hero">
      <div className="hero__body">
        <ViewTitle className="hero__title">{props.title}</ViewTitle>
        <Paragraph className="hero__description">{props.description}</Paragraph>
        <div className="hero__button-container">
          <Link to="/recommend" className="button button--dark">
            Рекомендую!
          </Link>
          <Link to="/apply" className="button button--light">
            Хочу к вам
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
